import http from '../_http'

const signout = {
  //default
  summarySignout : (m) => { return http.get(`manager/management/signout`, m); },
  listSignout : (m) => { return http.post(`manager/management/signout/list`, m); },
  detailSignout : (m) => { return http.get(`manager/management/signout/${m.id}`); },

  startSignout : (m) => { return http.post(`manager/management/signout/start`, m); },
  stopSignout : (m) => { return http.post(`manager/management/signout/stop`, m); },

  //crud
  insertSignout : (m) => { return http.post(`manager/management/signout`, m); },
  updateSignout : (m) => { return http.put(`manager/management/signout`, m); },
  deleteSignout : (m) => { return http.delete(`manager/management/signout/${m.id}`); },

  //service
  continueService : (m) => { return http.post(`manager/management/signout/continue`, m); },
  endService : (m) => { return http.post(`manager/management/signout/end`, m); },
}

export default signout

export { signout }